import axios from 'axios'
import config from '../config'

const postcode = {
    state: {
        cityItems: [],
        areaItems: [],
        codeItems: []

    },
    mutations: {
         getCity: (state, cityItems) => state.cityItems = cityItems,
         getArea: (state, areaItems) => state.areaItems = areaItems,
         getCode: (state, codeItems) => state.codeItems = codeItems,

    },
    actions: {
            async fetchCity({commit}){
                const response = await axios.post(
                    config.LOAD_CITY
                );
                commit('getCity', response.data.citys)
            },
            async fetchArea({commit}, cityName){
                const response = await axios.post(
                    config.LOAD_AREA,  cityName
                );
                commit('getArea', response.data.areas)
            },
            async fetchCode({commit}, data){
                await axios({
                    method:'post',
                    url: config.LOAD_CODE,
                    data: data
                })
                .then((result) => {
                    commit('getCode', result.data.code)
                }).catch((err) => {
                    console.log(err);
                });

            }
    },
    getters: {
         getCityItems: state=>state.cityItems,
         getAreaItems: state=>state.areaItems,
         getCodeItems: state => state.codeItems
    }
}

export default postcode;